import { FC } from 'react';

import { IMG_PLACEHOLDER } from '@/ux-legacy/uikit/components/components-index';
type Props = {
  data: {
    id?: string;
    image: string;
    name: string;
    description?: string;
  };
  edit?: boolean;
  onNameChange?: (name: string) => void;
};
const MarketplaceListingItem: FC<Props> = ({ data, edit = false, onNameChange = (name) => {} }) => {
  return (
    <>
      <div className="w-full h-full overflow-hidden relative rounded-md md:rounded-xl">
        <img
          src={data.image || IMG_PLACEHOLDER}
          className="w-full h-full object-cover rounded-xl hover:scale-150 transition-transform duration-300"
          alt="listing"
          loading="lazy"
        ></img>
        <div
          className={`absolute top-0 left-0 text-sm md:text-base capitalize text-white whitespace-nowrap max-w-[90%] truncate ${
            edit ? '' : 'bg-[rgba(26,43,73,0.75)]'
          }  rounded-br-md md:rounded-br-xl p-1 md:p-2`}
        >
          {edit ? (
            <div className="px-2 py-2 rounded-2xl border border-dashed text-black border-[#707070] w-[75%]">
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="given-name"
                defaultValue={data.name}
                required
                className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm  focus:outline-none sm:text-sm"
                onChange={(event) => {
                  onNameChange(event.target.value);
                }}
              />
            </div>
          ) : (
            <>{data?.name}</>
          )}
        </div>
      </div>
    </>
  );
};

export default MarketplaceListingItem;
